import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VNavigationDrawer, {
    style: _vm.positionTop,
    attrs: {
      "id": "app-drawer",
      "mini-variant": _vm.miniVariant,
      "mobile-breakpoint": _vm.$vuetify.breakpoint.thresholds.sm,
      "app": "",
      "floating": "",
      "persistent": "",
      "width": "260"
    },
    model: {
      value: _vm.inputValue,
      callback: function ($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  }, [_c(VImg, {
    attrs: {
      "src": _vm.image,
      "gradient": _vm.sidebarOverlayGradiant,
      "height": "100%"
    }
  }, [_c(VList, {
    attrs: {
      "expand": ""
    }
  }, [_c('core-drawer-logo', {
    attrs: {
      "color": _vm.vuetifyColorHex(_vm.color),
      "hasDefaultLogo": _vm.isDefaultSvgLogo(),
      "logo": _vm.sidebarLogo,
      "orientation": _vm.sidebarLogoOrientation,
      "byLine": _vm.sidebarLogoByline
    }
  }), _vm._l(_vm.cleanedLinks, function (item, i) {
    return _c('core-drawer-item', {
      key: i,
      attrs: {
        "item": item
      }
    });
  })], 2)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };